export type RpcError = {
  status?: number;
  response?: {
    body?: { error?: { code?: number; message?: string; details?: string } };
  };
  message?: string;
};

export const getRpcError = (
  error: unknown
): { code?: number; status?: number; message: string } => {
  const e = error as RpcError;
  const err = e?.response?.body?.error;
  return {
    code: err?.code,
    status: e?.status,
    message: err?.details ?? err?.message ?? e?.message ?? '',
  };
};

export const cleanRpcError = (error: unknown): string =>
  getRpcError(error)
    .message.replace(/^rpc error:.*?desc = /, '')
    .replace(/\.?\s*error_id:.*$/s, '')
    .trim() || 'Something went wrong.';
